import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import styles from "./SummaryItemComponent.module.scss";

interface ToppingModel {
  name: string;
  price: string;
  count?: number;
}

export interface SummaryItemComponentProps {
  count: number;
  description: string;
  size?: string;
  basePrice?: string;
  price: string;
  extraNote?: string;
  toppings?: ToppingModel[];
  /** Trailing controls, e.g. the cart's quantity stepper and remove button. */
  actions?: ReactNode;
}

function SummaryItemComponent(props: SummaryItemComponentProps) {
  const {
    count,
    description,
    size,
    basePrice,
    price,
    extraNote,
    toppings,
    actions,
  } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.summaryItemContainer}>
      <div className={`body-bold-medium ${styles.summaryItemCount}`}>
        <p className={`body-bold-medium ${styles.summaryItemCountValue}`}>
          {count}
        </p>
      </div>
      <div className={styles.summaryItemAndToppingWrapper}>
        <div className={styles.summaryItemComponent}>
          <div className={styles.summaryItemTextGroup}>
            <p className={`body-bold-medium ${styles.summaryItemDescription}`}>
              {description}
            </p>
          </div>
          <div className={styles.summaryItemTextGroup}>
            {basePrice && (
              <p className={`body-medium ${styles.summaryItemBasePrice}`}>
                {basePrice}
              </p>
            )}
            <p className={`body-medium ${styles.summaryItemPrice}`}>{price}</p>
          </div>
        </div>
        {size && (
          <div className={styles.summaryItemTextGroup}>
            <p className={`body-medium ${styles.summaryItemSize}`}>
              {t("order.dish.size")}: {size}
            </p>
          </div>
        )}
        {toppings &&
          toppings.map((topping, index) => (
            <div key={index} className={styles.summaryItemTopping}>
              <i
                className={`la-level-up-alt icon-medium ${styles.toppingArrow}`}
              />
              <p className={`body-medium ${styles.toppingDescription}`}>
                {topping.count && topping.count > 1
                  ? `${topping.count}x ${topping.name} (${topping.price})`
                  : `${topping.name} (${topping.price})`}
              </p>
            </div>
          ))}
        {extraNote ? (
          <div className={styles.summaryItemTextGroup}>
            <p className={`body-medium ${styles.summaryItemNote}`}>
              {extraNote}
            </p>
          </div>
        ) : null}
        {actions ? (
          <div className={styles.summaryItemActions}>{actions}</div>
        ) : null}
      </div>
    </div>
  );
}

export default SummaryItemComponent;
